import { LovInfoDictionary } from './LovInfoDictionary.ts';
import { LovInfo } from './LovInfo.ts';
import * as frac_api from "../api/FracApi.ts";

export function convertToLabel(crop: frac_api.CropOrPest): LovInfo {
    try {
        return { "label": crop.common_name + " (" + crop.scientific_name + ") (" + crop.eppo_code + ")", "value": crop.scientific_name };

    } catch (error) {

        throw new Error(`Error converting crop to label; crop: ${JSON.stringify(crop)}; ` + error);
    }
}

